// Func = limiting Scope for this file

let lastScrollTop = 0;

(function () {
	const mainHeader = document.getElementById('header');

	window.onload = function () {
		scrollW(mainHeader);
		window.addEventListener('scroll', () => scrollW(mainHeader));

		// RELLAX
		if (document.body.offsetWidth > 990) {
			const rellax = new Rellax('.js-rellax', { center: true });
			const rellax_bg = new Rellax('.js-rellax-bg img', { center: true, speed: -3 });
		}
		let anchor = window.location.hash;
		if (anchor) {
			ConvertAnchorToId(anchor);
		}
	};
})();

function scrollW(header, startFrom = 80) {
	//SET HEADER SCROLLING CLASSES
	const scrollTop = document.documentElement.scrollTop;

	header.classList.toggle('scroll', scrollTop > startFrom);
	header.classList.toggle('down', scrollTop > startFrom && scrollTop > lastScrollTop);
	header.classList.toggle('up', scrollTop > startFrom && scrollTop < lastScrollTop);

	lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // CHECK MOBILE NEGATIVE SCROLLING
}

function ScrollToSection(IdSection, margin){
	if (document.getElementById(IdSection)){
		let seccion = document.getElementById(IdSection);
		let posicion = seccion.getBoundingClientRect().top + window.scrollY - margin;
		window.scrollTo({ top: posicion, behavior: 'smooth' });
	}
}

function ConvertAnchorToId(anchor){
	var IdSection = anchor.substring(1).toLowerCase();
	if(IdSection == "in-room-amenities"){
		IdSection = "quad-20228",
		ScrollToSection(IdSection , 100);
	}
	else if(IdSection == "dining-amenities"){
		IdSection = "quad-20229",
		ScrollToSection(IdSection , 10);
	}
	else if(IdSection == "explore"){
		IdSection = "quad-20231",
		ScrollToSection(IdSection , 100);
	}
}
